import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let DiscountAdmissionsSpecialController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-special/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-special/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    listDiscountSpecial: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-special/list-discount-special`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-special/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-special/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-special/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default DiscountAdmissionsSpecialController
